import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type RemoveProps = IconComponentBaseProps;

export const Remove = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: RemoveProps) => {
  const maskId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M5.2085 10.625C5.03141 10.625 4.88301 10.5651 4.76329 10.4452C4.64343 10.3253 4.5835 10.1769 4.5835 9.99979C4.5835 9.82257 4.64343 9.67417 4.76329 9.55458C4.88301 9.43486 5.03141 9.375 5.2085 9.375H14.7918C14.9689 9.375 15.1173 9.43493 15.237 9.55479C15.3569 9.67465 15.4168 9.82313 15.4168 10.0002C15.4168 10.1774 15.3569 10.3258 15.237 10.4454C15.1173 10.5651 14.9689 10.625 14.7918 10.625H5.2085Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = { maskType: 'alpha' };
